import { jsx as i } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useResponsiveViewport as g, mediaQueries as V } from "../../../../../hooks/useResponsiveViewport.js";
import $ from "../../components/FilterButton/FilterButton.js";
import q from "../../../Popover/Popover.js";
import { PopoverContainerVariant as z, PopoverContainerPosition as H } from "../../../Popover/types.js";
import { TypographyElement as B, TypographyVariant as D } from "../../../Typography/types.js";
import O from "../../../Typography/Typography.js";
import L from "../../../../../hooks/element/useUniqueIdentifier.js";
import { memo as j } from "../../../../../external/preact/compat/dist/compat.module.js";
import { useMemo as E, useCallback as _, useEffect as A, useState as Q } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import c from "../../../../../hooks/useBooleanState.js";
import G from "../../../FormFields/InputText.js";
import J from "../../../../../hooks/useCommitAction/useCommitAction.js";
import { Fragment as K } from "../../../../../external/preact/dist/preact.module.js";
import { isNull as W } from "../../../../../utils/value/is.js";
import { isEmptyString as X } from "../../../../../utils/value/string.js";
import { CommitAction as S } from "../../../../../hooks/useCommitAction/types.js";
const Z = (s) => !s || X(s), ee = /* @__PURE__ */ (() => {
  const s = (e) => {
    const { editAction: f, name: a, onChange: u, onValueUpdated: r } = e, [l, n] = Q(e.value), m = _(
      (t) => {
        const p = t.target.value.trim();
        n(p), r(p);
      },
      [r]
    );
    return A(() => {
      if (f === S.CLEAR) {
        const t = "";
        n(t), r(t), u(t);
      }
      f === S.APPLY && u(l ?? "");
    }, [l, f, u, r]), /* @__PURE__ */ i(G, { name: a, value: l, onInput: m });
  };
  return (e) => /* @__PURE__ */ i(s, { ...e });
})(), te = ({ render: s, ...e }) => {
  var N;
  const f = g(V.down.xs), [a, u] = c(!1), [r, l] = c(!1), n = E(() => e.isValueEmpty ?? Z, [e.isValueEmpty]), [m, t] = c(n(e.value)), [p, v] = c(!1), [w, h] = c(!1), [T, M] = c(n(e.value)), b = L(), I = E(() => s ?? ee, [s]), k = _(
    (o) => {
      const d = n(o ?? void 0);
      t(d), M(W(o)), h(p ? o !== e.value : !d);
    },
    [n, t, M, h, p, e.value]
  ), { commitAction: x, commitActionButtons: R, committing: C, resetCommitAction: P } = J({
    applyDisabled: T || !w,
    resetDisabled: m
  }), [y, F] = E(() => {
    const o = (d) => () => {
      d !== a && (d && (P(), h(!1), v(!1)), u(d), l(d));
    };
    return [o(!1), o(!0)];
  }, [u, a, P, l, v, h]);
  A(() => {
    if (r) {
      const o = n(e.value);
      l(!1), t(o), v(!o);
    }
  }, [e.value, r, n, l, t, v]), A(() => {
    C && y(), t(m);
  }, [C, y, t, m]);
  const U = g(V.only.sm), Y = g(V.only.md);
  return /* @__PURE__ */ i(K, { children: [
    /* @__PURE__ */ i("div", { className: `adyen-pe-filter adyen-pe-filter--${e.type}`, children: E(
      () => /* @__PURE__ */ i(
        $,
        {
          classNameModifiers: [
            ...e.appliedFilterAmount ? ["with-counter"] : [],
            ...e.classNameModifiers ?? [],
            ...a ? ["active"] : [],
            ...m ? [] : ["has-selection"]
          ],
          onClick: a ? y : F,
          tabIndex: 0,
          ref: b,
          children: /* @__PURE__ */ i("div", { className: "adyen-pe-filter-button__default-container", children: [
            /* @__PURE__ */ i(
              O,
              {
                el: B.SPAN,
                variant: D.BODY,
                stronger: !0,
                className: "adyen-pe-filter-button__label",
                children: e.label
              }
            ),
            !!e.appliedFilterAmount && /* @__PURE__ */ i("div", { className: "adyen-pe-filter-button__counter-wrapper", children: /* @__PURE__ */ i(
              O,
              {
                el: B.SPAN,
                variant: D.BODY,
                stronger: !0,
                className: "adyen-pe-filter-button__counter",
                children: e.appliedFilterAmount
              }
            ) })
          ] })
        }
      ),
      [
        e.appliedFilterAmount,
        e.classNameModifiers,
        e.label,
        a,
        m,
        y,
        F,
        b
      ]
    ) }),
    a && /* @__PURE__ */ i(
      q,
      {
        actions: R,
        title: (N = e.title) == null ? void 0 : N.trim(),
        variant: z.POPOVER,
        modifiers: ["filter"],
        open: a,
        "aria-label": `${e.label}`,
        dismiss: y,
        dismissible: !1,
        withContentPadding: e.withContentPadding ?? !0,
        divider: !0,
        targetElement: b,
        disableFocusTrap: !1,
        position: H.BOTTOM,
        containerSize: e.containerSize,
        showOverlay: f,
        fitPosition: U || Y,
        children: I({ ...e, editAction: x, onValueUpdated: k })
      }
    )
  ] });
}, be = j(te);
export {
  be as default
};
